var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "portlet-body" },
      [
        _c("fluxo-caixa-gerencial-filtro", {
          attrs: { "color-selected": "blue", "color-deselected": "white" },
        }),
        _vm._v(" "),
        _c("wes-message", _vm._b({}, "wes-message", _vm.messagePanel, false)),
        _vm._v(" "),
        _vm.exibirTabela
          ? _c("div", { staticClass: "fcg-barra-grid" }, [
              _c(
                "div",
                { staticClass: "fcg-checkboxes-dimensoes" },
                [
                  _vm._l(_vm.checkboxesDimensoes, function (dim, idx) {
                    return [
                      dim.tipo === "principal"
                        ? _c(
                            "label",
                            { key: "dim-p-" + idx, staticClass: "mt-checkbox" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(dim.label) +
                                  "  \n                        "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: dim.ref.ativo,
                                    expression: "dim.ref.ativo",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(dim.ref.ativo)
                                    ? _vm._i(dim.ref.ativo, null) > -1
                                    : dim.ref.ativo,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = dim.ref.ativo,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            dim.ref,
                                            "ativo",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            dim.ref,
                                            "ativo",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(dim.ref, "ativo", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span"),
                            ]
                          )
                        : _c(
                            "label",
                            { key: "dim-n-" + idx, staticClass: "mt-checkbox" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(dim.label) +
                                  "  \n                        "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      dim.ref.niveisVisiveis[dim.indiceNivel],
                                    expression:
                                      "dim.ref.niveisVisiveis[dim.indiceNivel]",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    dim.ref.niveisVisiveis[dim.indiceNivel]
                                  )
                                    ? _vm._i(
                                        dim.ref.niveisVisiveis[dim.indiceNivel],
                                        null
                                      ) > -1
                                    : dim.ref.niveisVisiveis[dim.indiceNivel],
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        dim.ref.niveisVisiveis[dim.indiceNivel],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            dim.ref.niveisVisiveis,
                                            dim.indiceNivel,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            dim.ref.niveisVisiveis,
                                            dim.indiceNivel,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        dim.ref.niveisVisiveis,
                                        dim.indiceNivel,
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span"),
                            ]
                          ),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "fcg-exportar-wrapper" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default",
                      attrs: { type: "button", title: "Colapsar um nível" },
                      on: { click: _vm.colapsarNivel },
                    },
                    [_c("i", { staticClass: "fa fa-minus" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default",
                      attrs: { type: "button", title: "Expandir um nível" },
                      on: { click: _vm.expandirNivel },
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "fcg-toolbar-sep",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _vm.previstoRealizadoAtual
                    ? [
                        _vm._l(_vm.tiposColunas, function (tipo) {
                          return _c(
                            "button",
                            {
                              key: "tipo-col-" + tipo.id,
                              staticClass:
                                "btn btn-sm btn-default fcg-btn-toggle",
                              class: { active: _vm.tiposVisiveis[tipo.id] },
                              attrs: { type: "button", title: tipo.title },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleTipoColuna(tipo.id)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.tiposVisiveis[tipo.id]
                                  ? "fa-check-square-o"
                                  : "fa-square-o",
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(tipo.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "fcg-toolbar-sep",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default fcg-btn-toggle",
                      class: { active: _vm.agrupaPorTipoConta },
                      attrs: {
                        type: "button",
                        title:
                          "Agrupa as contas bancárias por tipo de conta ao mostrar saldos",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$store.commit(
                            "pivotgrid/toggleAgrupaPorTipoConta"
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-list" }),
                      _vm._v(" Agrupar tipo de conta\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default",
                      attrs: { type: "button" },
                      on: { click: _vm.exportarExcel },
                    },
                    [
                      _c("i", { staticClass: "fa fa-file-excel-o" }),
                      _vm._v(" Exportar Excel\n                "),
                    ]
                  ),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.exibirTabela
          ? _c("fluxo-caixa-tabela", {
              ref: "tabelaFluxo",
              attrs: {
                movimentacoes: _vm.data || [],
                "saldo-inicial-data": _vm.saldoInicialData,
                "saldo-final-data": _vm.saldoFinalData,
                "previsto-realizado": _vm.previstoRealizadoAtual,
                "tipos-visiveis": _vm.tiposVisiveisLista,
                "config-dimensoes": _vm.dimensoes,
                "agrupa-por-tipo-conta": _vm.agrupaPorTipoConta,
                periodos: _vm.periodosAtuais,
              },
              on: { "cell-click": _vm.onCelulaClique },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("br"),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c(
          "span",
          {
            staticClass: "caption-subject font-green-sharp bold uppercase",
            attrs: { id: "TituloBalanceteGerencial" },
          },
          [_vm._v("Fluxo de Caixa Gerencial")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }